import PropTypes from 'prop-types';

import { Wrapper, Progress } from './ProgressBar.style';

const ProgressBar = ({ width }) => (
  <Wrapper>
    <Progress width={width} />
  </Wrapper>
);

ProgressBar.propTypes = {
  width: PropTypes.number.isRequired,
};

export default ProgressBar;
